import $ from "jquery";

class StickyNav {
    constructor($header, $hero) {
        this.$header = $header;
        this.$hero = $hero;
        this.$body = $('body');
        this.heroHeight = 0;

        this.calcTriggerPoints();
        this.toggleSticky();
        this.bindEvents();
    }

    bindEvents() {
        $(window).on('resize', this.resize.bind(this)) //binds to this instance, otherwise it relates to nothing.
            .on('scroll', this.scroll.bind(this));
    }

    scroll() {
        this.toggleSticky();
    }

    resize() {
        this.calcTriggerPoints();
        this.toggleSticky();
    }

    toggleSticky() {
        if ($(window).scrollTop() <= 15) {
            this.$header.removeClass('header--fixed');
            this.$body.removeClass('sticky-active');
        } else if ($(window).scrollTop() > this.heroHeight && !this.$body.is(".sticky-active")) {
            this.$header.addClass('header--fixed');
            this.$body.outerHeight();
            this.$body.addClass('sticky-active');
        }
    }

    calcTriggerPoints() {
        this.heroHeight = this.$hero.outerHeight();
    }
}

export default StickyNav;
